import React, { useState } from "react";

interface LoginProps {
  onLogin: (username: string, password: string) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError("请输入用户名和密码");
      return;
    }
    onLogin(username.trim(), password.trim());
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "100px auto",
        padding: "40px",
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        borderRadius: "16px",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
      }}
    >
      <h1
        style={{
          fontSize: "28px",
          fontWeight: "600",
          marginBottom: "16px",
          color: "#00FFD1",
          textAlign: "center",
          textShadow: "0 0 20px rgba(0, 255, 209, 0.5)",
        }}
      >
        登录
      </h1>
      <div
        style={{
          marginBottom: "32px",
          padding: "12px 16px",
          backgroundColor: "rgba(255, 193, 7, 0.15)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
          color: "#FFC107",
          borderRadius: "8px",
          fontSize: "13px",
          lineHeight: "1.5",
          border: "1px solid rgba(255, 193, 7, 0.3)",
        }}
      >
        <div style={{ fontWeight: "500", marginBottom: "4px" }}>🔑 安全提示</div>
        <div>用户名和密码是您访问数据的唯一凭证，请设置足够复杂的组合并妥善保管，切勿泄露给他人。</div>
      </div>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "20px" }}>
          <label
            htmlFor="username"
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#E0E0E0",
            }}
          >
            用户名
          </label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setError("");
            }}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              outline: "none",
              color: "#E0E0E0",
              transition: "all 0.2s",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#00FFD1";
              e.target.style.boxShadow = "0 0 15px rgba(0, 255, 209, 0.3)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "rgba(255, 255, 255, 0.2)";
              e.target.style.boxShadow = "none";
            }}
            autoComplete="username"
          />
        </div>
        <div style={{ marginBottom: "24px" }}>
          <label
            htmlFor="password"
            style={{
              display: "block",
              marginBottom: "8px",
              fontSize: "14px",
              fontWeight: "500",
              color: "#E0E0E0",
            }}
          >
            密码
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError("");
            }}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "16px",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              outline: "none",
              color: "#E0E0E0",
              transition: "all 0.2s",
            }}
            onFocus={(e) => {
              e.target.style.borderColor = "#00FFD1";
              e.target.style.boxShadow = "0 0 15px rgba(0, 255, 209, 0.3)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "rgba(255, 255, 255, 0.2)";
              e.target.style.boxShadow = "none";
            }}
            autoComplete="current-password"
          />
        </div>
        {error && (
          <div
            style={{
              marginBottom: "20px",
              padding: "12px",
              backgroundColor: "rgba(255, 82, 82, 0.2)",
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
              color: "#FF5252",
              borderRadius: "8px",
              fontSize: "14px",
              border: "1px solid rgba(255, 82, 82, 0.3)",
            }}
          >
            {error}
          </div>
        )}
        <button
          type="submit"
          style={{
            width: "100%",
            padding: "12px",
            fontSize: "16px",
            fontWeight: "500",
            color: "#0a0a0f",
            backgroundColor: "#00FFD1",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "all 0.2s",
            boxShadow: "0 0 20px rgba(0, 255, 209, 0.4)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#00FFFF";
            e.currentTarget.style.boxShadow = "0 0 30px rgba(0, 255, 209, 0.6)";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#00FFD1";
            e.currentTarget.style.boxShadow = "0 0 20px rgba(0, 255, 209, 0.4)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          登录
        </button>
      </form>
    </div>
  );
};

export default Login;
